import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button } from '@mui/material';

export const EventsLink = () => {
  return (
    <Button
      component={RouterLink}
      to="/guests/event-plans"
      sx={{ color: 'text.primary' }}
    >
      Events
    </Button>
  );
};
